import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { AppBar, Box, Button, IconButton, Toolbar, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';

const ProtectedInspectionRoute = ({ children }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isAuthenticated = localStorage.getItem('token') !== null;

  if (!isAuthenticated) {
    return <Navigate to="/inspection-signin" replace />;
  }

  const handleSignOut = () => {
    localStorage.clear();
    navigate('/landing');
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <AppBar position="sticky" sx={{ backgroundColor: '#ececec', color: '#111', top: 0 }}>
        <Toolbar sx={{ minHeight: { xs: 56, sm: 64 }, px: { xs: 1.5, sm: 2 }, gap: 1 }}>
          <Typography
            variant={isMobile ? 'subtitle1' : 'h6'}
            sx={{
              flexGrow: 1,
              color: '#111',
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            Inspection Portal
          </Typography>
          {isMobile ? (
            <IconButton aria-label="Sign out" onClick={handleSignOut} sx={{ color: '#111' }}>
              <LogoutIcon />
            </IconButton>
          ) : (
            <Button
              color="inherit"
              startIcon={<LogoutIcon />}
              onClick={handleSignOut}
              sx={{ color: '#111', minHeight: 44 }}
            >
              Sign Out
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Box sx={{ px: { xs: 1.5, sm: 2 }, py: { xs: 2, sm: 3 }, pb: 4, maxWidth: 1200, mx: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
};

export default ProtectedInspectionRoute;
